// src/components/admin/TenantsTable.tsx
import type { TenantUsageRow } from '@/types/admin';

interface Props {
  rows: TenantUsageRow[];
  onTenantClick: (tenantId: string | null) => void;
}

const fmtN = (v: number) => new Intl.NumberFormat('it-IT').format(v);

export const TenantsTable = ({ rows, onTenantClick }: Props) => {
  if (rows.length === 0) {
    return <div className="text-sm text-muted-foreground">Nessun tenant attivo nel periodo.</div>;
  }
  return (
    <table className="w-full text-sm">
      <thead className="bg-muted/50">
        <tr>
          <th className="text-left text-xs font-semibold px-3 py-2">Tenant</th>
          <th className="text-left text-xs font-semibold px-3 py-2">Utenti attivi</th>
          <th className="text-left text-xs font-semibold px-3 py-2">Prompt</th>
          <th className="text-left text-xs font-semibold px-3 py-2">Token</th>
          <th className="text-left text-xs font-semibold px-3 py-2">Sessioni</th>
          <th className="text-left text-xs font-semibold px-3 py-2">File</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr
            key={r.tenantId ?? 'no-tenant'}
            className="border-t cursor-pointer hover:bg-muted/30"
            onClick={() => onTenantClick(r.tenantId)}
          >
            <td className="px-3 py-2">
              <div className="font-medium">{r.name ?? '(no tenant)'}</div>
              {r.tenantId && <div className="text-xs text-muted-foreground font-mono">{r.tenantId}</div>}
            </td>
            <td className="px-3 py-2 font-mono">{fmtN(r.activeUsers)}</td>
            <td className="px-3 py-2 font-mono">{fmtN(r.prompts)}</td>
            <td className="px-3 py-2 font-mono">{fmtN(r.inputTokens + r.outputTokens)}</td>
            <td className="px-3 py-2 font-mono">{fmtN(r.sessions)}</td>
            <td className="px-3 py-2 font-mono">{fmtN(r.files)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
